import { Col, Row, Tabs } from "antd";
import to from "await-to-js";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { GoBackButton } from "../../../../components/GoBackButton/GoBackButton";
import { Table } from "../../../../components/Table/Table";
import { centralRegistryService } from "../../../../modules/ministry/centralRegistry/centralRegistry.service";
import { RegistryObligeeDetalji } from "../../../../modules/ministry/centralRegistry/centralRegistry.types";
import { useScreenResize } from "../../../../utils/useScreenResize";
import style from "./ObligeeRegistryDetails.module.scss";

export const ObligeeRegistryDetails = () => {
  const { t } = useTranslation();
  const { width } = useScreenResize();
  const [obveznik, setDetaljiObveznika] =
    useState<RegistryObligeeDetalji | null>(null);

  const calculateMaxWidthCss = `calc(100vw - ${
    width < 992 ? "280px" : "380px"
  })`;

  // Todo: handle when we implement other role
  const routePath = "/mfin/centralniRegistar/registri";

  const getDetaljiObveznika = async (obrazacId: string | null) => {
    if (!obrazacId) return;
    const [err, res] = await to(
      centralRegistryService.getDetaljiObveznika(+obrazacId)
    );
    if (err || !res.success) return;
    setDetaljiObveznika(res.data);
  };

  useEffect(() => {
    let queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");

    getDetaljiObveznika(id);
  }, []);

  const colDef = [
    {
      dataIndex: "tipDozvole",
      width: "240px",
      title: t("REGISTRI.TIP_DOZVOLE"),
    },
    {
      dataIndex: "brojResenja",
      width: "240px",
      title: t("REGISTRI.BROJ_RESENJA"),
    },
    {
      dataIndex: "datumUpisa",
      width: "240px",
      title: t("REGISTRI.DATUM_UPISA"),
    },
    {
      dataIndex: "datumIspisa",
      width: "240px",
      title: t("REGISTRI.DATUM_ISPISA"),
    },
  ];

  const TAB_CONFIG = [
    {
      key: "alkohol",
      label: t("COMMON.ALKOHOL"),
      children: (
        <div
          style={{
            maxWidth: calculateMaxWidthCss,
          }}
        >
          <Table
            columns={colDef}
            scrollConfig={["#exciseList"]}
            dataSource={obveznik?.registri.alkohol}
            name={`alkohol`}
          />
        </div>
      ),
    },
    {
      key: "duvan",
      label: t("COMMON.DUVAN"),
      children: (
        <div
          style={{
            maxWidth: calculateMaxWidthCss,
          }}
        >
          <Table
            columns={colDef}
            scrollConfig={["#exciseList"]}
            dataSource={obveznik?.registri.duvan}
            name={`duvan`}
          />
        </div>
      ),
    },
    {
      key: "kafa",
      label: t("COMMON.KAFA"),
      children: (
        <div
          style={{
            maxWidth: calculateMaxWidthCss,
          }}
        >
          <Table
            columns={colDef}
            scrollConfig={["#exciseList"]}
            dataSource={obveznik?.registri.kafa}
            name={`kafa`}
          />
        </div>
      ),
    },
  ];

  const [defaultKey, setDefaultKey] = useState<string>("alkohol");
  const handleChange = (page: string) => {
    let queryParams = new URLSearchParams();
    queryParams.set("active", page);
    window.history.replaceState(null, "", "?" + queryParams.toString());
    setDefaultKey(page);
  };

  return (
    <div className={style.container}>
      <div className={style.innerContainer}>
        <GoBackButton routePath={routePath} />
        <Row className={style.row}>
          <Col span={24}>
            <h2>
              {t("REGISTRI.NAZIV_PRIVREDNOG_SUBJEKTA", {
                naziv: obveznik?.drustvoInfo?.naziv,
              })}
            </h2>
          </Col>
        </Row>
        <Row className={style.row}>
          <Col span={12}>
            {t("REGISTRI.ADRESA_PRIVREDNOG_SUBJEKTA", {
              adresa: obveznik?.drustvoInfo?.adresa,
            })}
          </Col>
          <Col span={6}>
            {t("REGISTRI.PIB", {
              pib: obveznik?.drustvoInfo?.pib,
            })}
          </Col>
        </Row>
        <Row>
          <Tabs
            destroyInactiveTabPane
            defaultActiveKey={defaultKey}
            items={TAB_CONFIG}
            onChange={handleChange}
            activeKey={defaultKey}
          />
        </Row>
      </div>
    </div>
  );
};
